/** Shopify CDN: Minification failed

Line 26:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 27:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 36:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 38:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 48:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 52:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 80:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 80:36 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 14:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 15:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 24:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 26:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 36:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 40:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 68:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 68:36 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.querySelector('.wbquicksuccess').classList.add('hidden'); // Webibazaar Quickview Message
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
          this.querySelector('.wbquicksuccess').classList.remove('hidden'); // Webibazaar Quickview Message
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
